import axios from 'axios';
// import {HEADER} from 'store/api/olbAccessControl/olbAccessControlConstants';
import {ActionTypes as ConfigActionTypes} from 'store/config/configConstants';

const fetchConfig = () => {
    let url = location.origin + location.pathname + 'config';
    if(process.env.NODE_ENV === 'development'){
        // url = location.origin + location.pathname +'dummy/data/config-service.json';
        url = location.origin + '/dummy/data/config-service.json';
        // console.log('[configActions/fetchConfig] location.origin:', location.origin, 'location.pathname:', location.pathname, 'url:', url)
    }
    const header = {
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin':'*',
        'Access-Control-Allow-Credentials': 'true',
        'Access-Control-Allow-Methods': 'GET,OPTIONS',
        'Access-Control-Allow-Headers': '*'
    };

    return (dispatch:any) => {
        dispatch({
            type: ConfigActionTypes.FETCH_CONFIG,
            payload: axios({
                    method: 'get',
                    url,
                    headers: {...header}
                }
            ).then(data => {
                return new Promise((resolve, reject) => {
                    return resolve(data);
                })
            }).catch(err => {
                return new Promise((resolve, reject) => {
                    return reject(err);
                });
            })
        });
    };
};


export {
    fetchConfig
};


